import { useEffect, useState } from 'react';
import styles from '../../../../ApplicationMaintenance.module.scss';
import { AppComponent } from '../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Modal from '@mui/material/Modal';
import Base from '../../../../../Base/Base';
import Spinner from '../../../../../../components/UI/Spinner/Spinner';
import ApiErrors from '../../../../components/NewApplication/ApiErrors';
import Section from '../../../../components/NewApplication/Section';
import classNames from 'classnames';
import ComponentTypeSelect from './ComponentTypeSelect';
import Switch from '@mui/material/Switch';
import { CreateComponent, UpdateComponent } from '../../../../_api';
import ComponentUpdateRequest from '../../../../../../Classes/ResponseModels/ApplicationManagement/ComponentUpdateRequest';
import ExtensionTypeSelect from '../../../../components/ExtensionTypeSelect';
//component: AppComponent (/Classes/ResponseModels/ApplicationManagement/AppManagementModel.js)
const ComponentForm = ({
	app,
	currentUser,
	component = new AppComponent(),
	reload,
	readOnly,
	requirementNumber,
}) => {
	//isNew: indicates whether or not the form is for a new component or a
	const isNew = component.appID == null;
	const [modalOpen, setModalOpen] = useState(false);
	const [localComponent, setLocalComponent] = useState({ ...component });
	const [apiErrors, setApiErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [validationErrors, setValidationErrors] = useState([]);
	//on initial render, assign appID to localComponent if not already assigned
	useEffect(() => {
		if (!component.appID) {
			setLocalComponent({
				...localComponent,
				appID: app.appMaster.id,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setValidationErrors(AppComponent.validate(localComponent));
	}, [localComponent]);

	const resolveTextAreaNull = value => {
		if (value !== null) {
			return value;
		} else {
			return '';
		}
	};
	const handleSave = () => {
		let request = new ComponentUpdateRequest(
			app,
			currentUser,
			localComponent
		);
		request.RequirementNumber = requirementNumber;
		setIsLoading(true);
		if (isNew) {
			CreateComponent(request).then(response => {
				if (response.App?.Errors?.length > 0) {
					setApiErrors(response.App.Errors);
					setIsLoading(false);
				} else {
					setIsLoading(false);
					reload();
				}
			});
		} else {
			UpdateComponent(request).then(response => {
				if (response.App?.Errors?.length > 0) {
					setApiErrors(response.App.Errors);
					setIsLoading(false);
				} else {
					setIsLoading(false);
					reload();
				}
			});
		}
	};

	const handleChange = e => {
		setLocalComponent({
			...localComponent,
			[e.target.name]: e.target.value,
		});
	};

	const handleCheckboxChange = e => {
		setLocalComponent({
			...localComponent,
			[e.target.name]: e.target.checked,
		});
	};

	const handleExtensionTypeChange = e => {
		setLocalComponent({
			...localComponent,
			extension:
				e.target.value != null
					? {
							fiid: e.target.value,
					  }
					: null,
		});
	};

	return (
		<div>
			<div>
				<div className={styles.controlsContainer}>
					<Button
						variant='outlined'
						id='app_ComponentForm_modal_open'
						onClick={() => setModalOpen(true)}
						startIcon={
							isNew ? (
								<MaterialIcon icon='add' />
							) : (
								<MaterialIcon icon='edit' />
							)
						}
						disabled={readOnly}
					>
						{isNew ? 'Add Component' : 'Update'}
					</Button>
				</div>
				<Modal
					open={modalOpen}
					onClose={() => {
						setApiErrors([]);
						setLocalComponent({ ...component });
						setModalOpen(false);
					}}
				>
					<div className={styles.Modal}>
						<Base
							title={
								isNew
									? 'Create App Component'
									: 'Update App Component'
							}
						>
							{isLoading ? (
								<Spinner />
							) : (
								<>
									<ApiErrors errors={apiErrors} />
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											startIcon={
												<MaterialIcon icon='save' />
											}
											className={styles.editButton}
											id='Component_Save'
											disabled={
												readOnly ||
												validationErrors.length > 0
											}
										>
											Save
										</Button>
									</div>

									<Section label='Component'>
										<ComponentTypeSelect
											component={localComponent}
											setComponent={setLocalComponent}
											setIsLoading={setIsLoading}
										/>
										<ExtensionTypeSelect
											extensionTypes={
												app.extensions ?? []
											}
											handleChange={e => {
												handleExtensionTypeChange(e);
											}}
											extensionID={
												localComponent?.extension
													?.fiid ?? 0
											}
										/>
										<p className={styles.error}>
											{
												validationErrors.find(
													error =>
														error.field ===
														'extensionID'
												)?.message
											}
										</p>
										{/* label : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Label{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent?.label
														?.length
														? localComponent.label
																.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.label
												)}
												onChange={e => handleChange(e)}
												name='label'
												maxLength={256}
												rows={5}
												id='Component_label'
											/>
										</div>
										{/* subLabel : string (1024) */}
										<div className={styles.detailLabel}>
											<p>
												Sub Label{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent?.subLabel
														?.length
														? localComponent
																.subLabel.length
														: 0}
													/{1024})
												</span>
											</p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.subLabel
												)}
												onChange={e => handleChange(e)}
												name='subLabel'
												maxLength={1024}
												rows={5}
												id='Component_subLabel'
											/>
										</div>
										{/* required :  bool  */}
										<div className={styles.detailLabel}>
											<p>Required</p>
											<Switch
												checked={
													localComponent.required
												}
												name='required'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_required'
											/>
										</div>
										{/* modeAdd : bool */}
										<div className={styles.detailLabel}>
											<p>Include for 'Add' requests</p>
											<Switch
												checked={localComponent.modeAdd}
												name='modeAdd'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_modeAdd'
											/>
										</div>
										{/* modeModify : bool */}
										<div className={styles.detailLabel}>
											<p>Include for 'Modify' requests</p>
											<Switch
												checked={
													localComponent.modeModify
												}
												name='modeModify'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_modeModify'
											/>
										</div>
										{/* modeModify : bool */}
										<div className={styles.detailLabel}>
											<p>
												Include for 'Reactivate'
												requests
											</p>
											<Switch
												checked={
													localComponent.modeReactivate
												}
												name='modeReactivate'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_modeReactivate'
											/>
										</div>
										{/* hasDependant : bool */}
										<div className={styles.detailLabel}>
											<p>Has Dependant</p>
											<Switch
												checked={
													localComponent.hasDependant
												}
												name='hasDependant'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_hasDependant'
											/>
										</div>
										{/* visible : bool */}
										<div className={styles.detailLabel}>
											<p>
												Component is Visible on Initial
												render
											</p>
											<Switch
												checked={localComponent.visible}
												name='visible'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_visible'
											/>
										</div>
										{/* Active Flag : bool */}
										<div className={styles.detailLabel}>
											<p>Active Flag</p>
											<Switch
												checked={
													localComponent.activeFlag
												}
												name='activeFlag'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_visible'
											/>
										</div>
										{/*PrePopulationFlag : string  */}
										<div className={styles.detailLabel}>
											<p>Pre-Population Flag</p>
											<Switch
												checked={
													localComponent.prePopulationFlag ===
													'1'
												}
												name='prePopulationFlag'
												onClick={e => {
													e.target.value = e.target
														.checked
														? '1'
														: '0';
													handleChange(e);
												}}
												id='Component_prePopulationFlag'
											/>
										</div>
										{/*appRoleFlag : bool  */}
										<div className={styles.detailLabel}>
											<p>App Role Flag</p>
											<Switch
												checked={
													localComponent.appRoleFlag
												}
												name='appRoleFlag'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='Component_appRoleFlag'
											/>
										</div>
										{/*App Role Key : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												App Role Key{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent?.appRoleKey
														?.length
														? localComponent
																.appRoleKey
																.length
														: 0}
													/{256})
												</span>
											</p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.appRoleKey
												)}
												onChange={e => handleChange(e)}
												name='appRoleKey'
												maxLength={256}
												rows={5}
												id='Component_appRoleKey'
											/>
										</div>
										{/* defaultValue : string (1024) */}
										<div className={styles.detailLabel}>
											<p>
												Default Value{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent
														?.defaultValue?.length
														? localComponent
																.defaultValue
																.length
														: 0}
													/{512})
												</span>
											</p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.defaultValue
												)}
												onChange={e => handleChange(e)}
												name='defaultValue'
												maxLength={512}
												rows={5}
												id='Component_defaultValue'
											/>
										</div>
										{/* validationRoute : string (1024) */}
										<div className={styles.detailLabel}>
											<p>
												Validation Route{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent
														?.validationRoute
														?.length
														? localComponent
																.validationRoute
																.length
														: 0}
													/{512})
												</span>
											</p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.validationRoute
												)}
												onChange={e => handleChange(e)}
												name='validationRoute'
												maxLength={512}
												rows={5}
												id='Component_ValidationRoute'
											/>
										</div>
										{/* Order : number */}
										<div className={styles.detailLabel}>
											<p>Order </p>
											<input
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='number'
												value={localComponent.order}
												onChange={e => handleChange(e)}
												name='order'
												id='Component_Order'
											/>
										</div>
										{/* populationRoute : string (MAX) */}
										<div className={styles.detailLabel}>
											<p>
												Population Route{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent
														?.populationRoute
														?.length
														? localComponent
																.populationRoute
																.length
														: 0}
													/&#8734;)
												</span>
											</p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.populationRoute
												)}
												onChange={e => handleChange(e)}
												name='populationRoute'
												rows={5}
												id='Component_populationRoute'
											/>
										</div>
										{/*client Method : string (512) */}
										<div className={styles.detailLabel}>
											<p>
												Client Method{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localComponent
														?.clientMethod?.length
														? localComponent
																.clientMethod
																.length
														: 0}
													/{512})
												</span>
											</p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.clientMethod
												)}
												onChange={e => handleChange(e)}
												name='clientMethod'
												maxLength={512}
												rows={5}
												id='Component_clientMethod'
											/>
										</div>
										{/*extras : string (varchar(Max)) */}
										<div className={styles.detailLabel}>
											<p>Extras </p>
											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localComponent.extras
												)}
												onChange={e => handleChange(e)}
												name='extras'
												rows={5}
												id='Component_clientMethod'
											/>
										</div>
									</Section>
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											outlined
											startIcon={
												<MaterialIcon icon='save' />
											}
											className={styles.editButton}
											id='Component_Save2'
											disabled={
												readOnly ||
												validationErrors.length > 0
											}
										>
											Save
										</Button>
									</div>
								</>
							)}
						</Base>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default ComponentForm;
